import SriLankaColors from "../../view/_constants/SriLankaColors";
const AppColors = {
  Primary: "#000",
  Secondary: "#888",
  Success: "#080",

  Version: "#444",

  Start: "#444",
  Criterion: SriLankaColors.Muslim,
  GroundTruth: SriLankaColors.Tamil,
  Candidate: SriLankaColors.Sinhala,

  LessLight: "#444",
  Light: "#888",
  MoreLight: "#ccc",
  VeryLight: "#f8f8f8",
};

export default AppColors;
